import React from "react";
import { SvgIcon, SvgIconProps } from "@origin-digital/ods-icons";

export const IconElectricityLocal = (props: SvgIconProps) => (
  <SvgIcon titleAccess="Electricity request" color="neutral" {...props}>
    <path d="M15 21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21V20H15V21ZM12 2C15.865 2 19 5.135 19 9C19 11.38 17.81 13.4752 16 14.7402V17C16 17.55 15.55 18 15 18H9C8.45 18 8 17.55 8 17V14.7402C6.19 13.4752 5 11.38 5 9C5 5.135 8.135 2 12 2ZM12 4.00488C9.24504 4.00488 7.00006 6.24994 7 9.00488C7 10.6348 7.79959 12.1655 9.14453 13.1055L10 13.7002V16H14V13.6953L14.8555 13.0996C16.2002 12.1596 17 10.6297 17 9.00488C16.9999 6.24994 14.755 4.00488 12 4.00488Z" />
  </SvgIcon>
);
